import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IFilial } from 'src/app/pages/filiais/data/filiais';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';

@Component({
  selector: 'app-tab-filiais',
  templateUrl: './tab-filiais.component.html',
  styleUrls: ['./tab-filiais.component.scss']
})
export class TabFiliaisComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoFiliais = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  @Input() filiais: IFilial[] = [];
  @Input() companyId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();

  constructor(private readonly router: Router) { }

  public abrirEmNovaAba(filialId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/filiais/editar/${filialId}`]));

    window.open(url, '_blank');
  }
}
